import { createBrowserRouter, Navigate } from 'react-router-dom';

import { AuthLayout } from '@/app/layouts/AuthLayout';
import { DashboardLayout } from '@/app/layouts/DashboardLayout';
import { ProtectedRoute } from './ProtectedRoute';
import { LoginPage } from '@/pages/LoginPage';
import { ProfileEditorPage } from '@/pages/dashboard/ProfileEditorPage';
import { ProjectsPage } from '@/pages/dashboard/ProjectsPage';
import { CreateProjectPage } from '@/pages/dashboard/CreateProjectPage';
import { NotFoundPage } from '@/pages/NotFoundPage';
import { ProjectDetailPage } from '@/pages/ProjectDetailPage';
import { PortfolioPage } from '@/pages/PortfolioPage';

const basename = import.meta.env.PROD ? '/portfolio' : '/';

export const router = createBrowserRouter(
  [
    {
      index: true,
      element: <PortfolioPage />,
    },
    {
      path: 'project/:id',
      element: <ProjectDetailPage />,
    },
    {
      element: <AuthLayout />,
      children: [{ path: 'login', element: <LoginPage /> }],
    },
    {
      path: 'dashboard',
      element: <ProtectedRoute />,
      children: [
        {
          element: <DashboardLayout />,
          children: [
            { index: true, element: <Navigate to="profile" replace /> },
            { path: 'profile', element: <ProfileEditorPage /> },
            { path: 'projects', element: <ProjectsPage /> },
            { path: 'create_project', element: <CreateProjectPage /> },
            { path: 'projects/:id/edit', element: <CreateProjectPage /> },
          ],
        },
      ],
    },
    {
      path: '*',
      element: <NotFoundPage />,
    },
  ],
  { basename },
);
